import React, { useEffect, useState } from "react";
import { FaPlus, FaSearch, FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import _ from "lodash";

import { connect } from "react-redux";
import PActions from "../../Stores/redux/Persisted/Actions";
import UnpActions from "../../Stores/redux/Unpersisted/Actions";

import MainLayout from "../Common/MainLayout";
import DataTable from "../../Components/Table/DataTable";
import NewVisitForm from "./NewVisitForm";
import api from "../../Services/Api/api";
import etcModule from "../../Modules/etc/etc-module";
import apiPresets from "../../Services/Api/api-presets";
import { useNavigate } from "react-router-dom";

const VisitsScreen = ({ visits, user, setScreenState }) => {
  const [filteredVisits, setFilteredVisits] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    load();
  }, []);

  // Filter & Search Logic
  useEffect(() => {
    let filtered = visits.map((x) => ({
      ...x,
      schemeName: x.scheme?.name,
      officeName: (x.scheme?.office || x.office)?.name,
      visitorName: x.visitor?.name,

      subdivisionName: (x.scheme?.office || x.office)?.subdivision?.name,
      blockName: (x.scheme?.office || x.office)?.block?.name,
      deptBlockName: (x.scheme?.office || x.office)?.deptBlock?.name,
      circleName: (x.scheme?.office || x.office)?.circle?.name,
      lacName: (x.scheme?.office || x.office)?.lac?.name,

      creationDate: x.creationDate
        ? etcModule?.toViewableDateFormat(x.creationDate)
        : "",

      lastReviewedDate: x.lastReviewedDate
        ? etcModule?.toViewableDateFormat(x.lastReviewedDate)
        : "",

      reportDates: x.reports
        ?.filter((x) => x.status !== "pending")
        ?.map((x) =>
          x.lastSubmitDate
            ? etcModule?.toViewableDateFormat(x.lastSubmitDate)
            : "-"
        )
        .join(", "),

      visitStatus: _.startCase(x.status),

      reportStatuses: x.reports
        ?.filter((x) => x.status !== "pending")
        ?.map((x) => x.status)
        .join(", "),
    }));

    if (searchTerm) {
      filtered = filtered.filter(
        (visit) =>
          visit.office?.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          visit.scheme?.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          visit.scheme?.office?.name
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          visit.visitor?.name
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          visit.schemes?.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredVisits(filtered);
  }, [searchTerm, visits]);

  const load = async () => {
    setLoading(true);
    try {
      const visits = await apiPresets.getVisits();
      console.log({ visits });
      setScreenState({ visits });
    } catch (e) {
      console.error(e);
      toast.error(e.message);
    }
    setLoading(false);
  };

  const columns = [
    { label: "Creation Date", accessor: "creationDate" },

    { label: "Scheme", accessor: "schemeName" },
    { label: "Office", accessor: "officeName" },
    { label: "Block", accessor: "blockName" },

    { label: "Visitor", accessor: "visitorName" },

    { label: "Report Dates", accessor: "reportDates" },
    { label: "Report Status", accessor: "reportStatuses" },
  ];

  return (
    <MainLayout screenName="visits">
      <main className="visits-screen">
        {/* Page Title & Actions */}
        <div className="page-header">
          <h1>
            Visits & Inspections{" "}
            {loading ? <FaSpinner className="spinner" /> : null}
          </h1>
          <button className="add-btn" onClick={() => setShowModal(true)}>
            <FaPlus /> Add New Visit
          </button>
        </div>

        <div className="filters">
          <div className="search-bar">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* Table */}
        <DataTable
          columns={columns}
          data={filteredVisits}
          searchable={false}
          emptyList={loading ? "Loading Data" : null}
          onRowClick={(item) => navigate(`/visit/${item._id}`)}
        />

        {/* Modal for New Visit */}
        <NewVisitForm
          key={(!!showModal).toString()}
          {...{
            isOpen: showModal,
            onClose: () => setShowModal(false),
            onSuccess: () => load(),
          }}
        />
      </main>
    </MainLayout>
  );
};

const SCREEN_NAME = "VISITS_SCREEN";

const mapStateToProps = (state) => ({
  visits: state.vState[SCREEN_NAME]?.visits || [],
  user: state.pState.AUTH.user,
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VisitsScreen);
